import { useMutation } from "@apollo/client";
import { DEACTIVATE_USER, USERS_OF_ORGANISATION } from '../../apollo/queries';
import styles from "../DeleteProgram/DeleteProgram.module.scss";
import { client } from '../../apollo/client';

type DeactivateUserProps = {
  onToggle: Function;
  id: number;
};

export const DeactivateUser = ({ onToggle, id }: DeactivateUserProps) => {

  const [deactivateUser] = useMutation(DEACTIVATE_USER, {
    onCompleted: (data) => {
      if (data && data.deactivateUser && data.deactivateUser.code === 200) {
        onToggle();
        client.refetchQueries({
          include: [USERS_OF_ORGANISATION]
        })
      }
    },
  });

  const handleDeactivateUser = (id: number) => {
    deactivateUser({ variables: { deactivateUserId: id } });
  };

  return (
    <div className={styles.wrapper} style={{minHeight: "400px"}}>
      <div className={styles.header}>
        <p className={styles.subtitle}>
          Deactivate <span> - User</span>
        </p>
        <button className={styles.close} onClick={() => onToggle()}>
          X
        </button>
      </div>
      <header>Deactivate user with id: {id}</header>
      <br/>
      <div className={styles.buttons}>

        <button
          className={styles.delete}
          onClick={() => handleDeactivateUser(id)}
        >
          Deactivate
        </button>
        <button className={styles.cancel} onClick={() => onToggle()}>
          Cancel
        </button>
      </div>
    </div>
  );
};
